import enrollCmd from "../base/enrollCmd";

/**
 * Nothing to fancy here, just checks input values and builds the JSON to send to plugin manager
 * Suprema enroll by default enrolls 2 fingers as UNKNOWN_FINGER when sending {"enrollType":"suprema"}
 * to enroll a specific finger you need to specify the finger
 * @param finger 
 */
export const enrollSupremaMsg = (finger?) => {
    const fingerSelected = finger ? ",'finger':'" + finger + "'" : "";
    const enrolMessage = "{'enrollType':'" + enrollCmd.CMD_SUPREMA + "'" + fingerSelected + "'}";
    return enrolMessage;
};

/**
  * converts the message to object type.
  * @param {*} obj
  */
export const decodeSupremaPluginMsg = (obj) => {
    // TODO
};